<template>
  <section class="post-page" v-if="post">
    <div class="container post-card">
      <!-- Хлебные крошки -->
      <div class="breadcrumbs">
        <router-link to="/">Главная</router-link> /
        <router-link to="/blog">Блог</router-link> /
        <span>{{ post.title }}</span>
      </div>

      <!-- Картинка -->
      <div class="main-image">
        <img
          :src="post.image || require('@/assets/images/logo_x.svg')"
          alt="Post"
        />
      </div>

      <!-- Заголовок -->
      <h1 class="title">{{ post.title }}</h1>

      <!-- Контент -->
      <div class="content" v-html="post.content"></div>

      <!-- Дата + кнопка -->
      <div class="bottom-bar">
        <div class="date">{{ formatDate(post.created_at) }}</div>
        <button class="back-btn" @click="router.push('/blog')">
          Все новости
        </button>
      </div>
    </div>
  </section>
</template>

<script setup>
import { ref, onMounted } from "vue";
import { useRoute, useRouter } from "vue-router";
import moment from "moment";
import MarketplaceService from "@/services/marketplace";

const post = ref(null);
const route = useRoute();
const router = useRouter();

const formatDate = (date) => moment(date).format("D MMMM YYYY");

onMounted(async () => {
  const res = await MarketplaceService.getPost(route.params.id);
  post.value = res;
});
</script>

<style scoped>
.post-page {
  background: #f9fbfd;
  padding: 40px 20px 60px;
}
.container {
  margin: 0 auto;
}
.post-card {
  box-shadow: 0px 8px 24px 0px rgba(129, 135, 189, 0.15);
  border-radius: 30px;
  background-color: #fff;
  padding: 32px 48px;
}
.breadcrumbs {
  font-size: 20px;
  color: rgba(62, 62, 62, 1);
  margin-bottom: 24px;
}
.breadcrumbs a {
  text-decoration: none;
  color: rgba(62, 62, 62, 1);
  cursor: pointer;
}
.main-image {
  padding: 12px 48px;
}
.main-image img {
  width: 100%;
  border-radius: 12px;
  object-fit: cover;
  margin-bottom: 24px;
  max-height: 580px;
}
.title {
  font-size: 45px;
  font-weight: 700;
  color: rgba(0, 199, 130, 1);
  margin-bottom: 20px;
  padding: 0 48px;
}
.content {
  padding: 24px 48px;
  font-size: 20px;
  color: rgba(62, 62, 62, 1);
  line-height: 1.6;
  margin-bottom: 40px;
}
.bottom-bar {
  display: flex;
  justify-content: space-between;
  align-items: center;
  flex-wrap: wrap;
  gap: 16px;
}
.date {
  font-size: 14px;
  color: #888;
}
.back-btn {
  padding: 8px 20px;
  border: 1px solid #00c37f;
  background: none;
  color: #00c37f;
  border-radius: 8px;
  font-size: 14px;
  cursor: pointer;
  transition: 0.2s;
}
.back-btn:hover {
  background: #00c37f;
  color: white;
}
</style>
